import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Registration from "./registration";
import AdminLogin from "./AdminLogin";
import AdminPage from "./AdminPage";

const PrivateRoute = ({ children }) => {
  const isAuth = localStorage.getItem("adminAuth");
  return isAuth ? children : <Navigate to="/useradmin" />;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Registration/>} />
        <Route path="/useradmin" element={<AdminLogin />} />

        <Route
          path="/AdminPage"
          element={
            <PrivateRoute>
              <AdminPage/>
            </PrivateRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
